import styled from "@emotion/styled"
import { LayoutContext } from "contexts/LayoutProvider"
import { useContext } from "react"
import { processRichTextWithImagePrefix } from "reusable/processRichText"
import colors from "theme/colors"
import { NewText, TitleWithLine } from "ui"
import SideImageText from "ui/SideImageText"
import { extractAlt, extractProperty } from "utils"

const TextWrapper = styled.div<{ $flip: boolean }>`
  display: flex;
  flex-direction: column;
  gap: 12px;
  max-width: 700px;
  ${(props) => props.theme.breakpoints.up("md")} {
    gap: 36px;
    margin-left: ${(p) => (p.$flip ? "0px" : "110px")};
    margin-right: ${(p) => (p.$flip ? "110px" : "0px")};
    h5 {
      margin-top: 36px;
    }
  }
  ${(props) => props.theme.breakpoints.up("xl")} {
    gap: 55px;
    margin-left: ${(p) => (p.$flip ? "0px" : "220px")};
    margin-right: ${(p) => (p.$flip ? "220px" : "0px")};
    h5 {
      margin-top: 55px;
    }
  }
  p {
    margin: 0;
  }
`
const StyledBody = styled.div<{ $flip?: boolean }>`
  ${(props) => props.theme.breakpoints.up("md")} {
    padding-left: ${(p) => (p.$flip ? "70px" : "0")};
    padding-right: ${(p) => (p.$flip ? "0" : "70px")};
  }
  ${(props) => props.theme.breakpoints.up("xl")} {
    padding-left: ${(p) => (p.$flip ? "88px" : "0")};
    padding-right: ${(p) => (p.$flip ? "0" : "88px")};
  }

  a:hover{
    text-decoration:none;
  }
`

function ImageText({ data, isFirstHeading }: { data: any; isFirstHeading?: boolean }) {
  const { GRAPHQL_URL } = useContext(LayoutContext)
  const headline = extractProperty(data, "headline")
  const subtitle = processRichTextWithImagePrefix(
    extractProperty(data, "subTitle"),
    GRAPHQL_URL,
  )
  const body = processRichTextWithImagePrefix(
    extractProperty(data, "body"),
    GRAPHQL_URL,
  )
  const flip = extractProperty(data, "flip")
  const image = extractProperty(data, "image")

  return (
    <SideImageText gap={220} isSwitched={flip} image={image} flip={flip} alt={extractProperty(data, "altTextForImage") || extractAlt(data, "image") || headline || ""}>
      <TextWrapper $flip={flip}>
        {headline && (
          <TitleWithLine
            title={headline}
            titleColor={colors.black}
            largeDesktopFontSize={64}
            largeDesktopLineHeight="72px"
            titleFontSize={42.67}
            desktopLineHeight="51.2px"
            mobileTitleFontSize={36}
            mobileLineHeight="50.4px"
            component={isFirstHeading ? "h1" : "h2"}
          />
        )}
        {subtitle && (
          <NewText
            component={"div"}
            largeDesktopFontSize={36}
            largeDesktopLineHeight="52px"
            desktopFontSize={28}
            desktopFontWeight={400}
            desktopLineHeight={"39.2px"}
            mobileFontSize={20}
            mobileLineHeight={"28px"}
            dangerouslySetInnerHTML={{ __html: subtitle.replace(/h3/g, headline || !isFirstHeading ? "h3" : "h2") }}
          />
        )}

        {body && (
          <StyledBody>
            <NewText
              component={"div"}
              largeDesktopFontSize={20}
              largeDesktopLineHeight="30px"
              desktopFontSize={14}
              desktopFontWeight={400}
              desktopLineHeight={"20px"}
              mobileFontSize={16}
              mobileLineHeight={"28px"}
              dangerouslySetInnerHTML={{ __html: body }}
            />
          </StyledBody>
        )}
      </TextWrapper>
    </SideImageText>
  )
}

export default ImageText
